/**
 * Fracture Minds (strategem 59) — client preview for UI.
 * Must match `orders/strategemFractureMindsPreview.js` and execute logic in
 * `complete_strategem_implementations.js` id 59.
 */

export const FRACTURE_MINDS_STRATEGEM_ID = 59;

const FRONT_FLANK_ZONES = ['front', 'flank'];

/** @see orders/strategemFractureMindsPreview.js — must stay aligned */
const COMBINED_FACTION_NAMES_COUNTING_AS_ASRAH = new Set([
  'The Conspiracy',
  'The Corrupted Core',
  'The Forsaken Pact',
  'The Hollow',
]);

export function unitCountsAsAsrahForFractureMinds(unit) {
  if (!unit || typeof unit !== 'object') {
    return false;
  }
  const factionName = unit.faction_name || unit.faction;
  if (factionName === 'Asrah') {
    return true;
  }
  if (typeof factionName !== 'string' || factionName.length === 0) {
    return false;
  }
  return COMBINED_FACTION_NAMES_COUNTING_AS_ASRAH.has(factionName);
}

export function countDeployedAsrahUnitsForFractureMinds(player) {
  if (!player || !player.playedOrders) {
    return 0;
  }
  let count = 0;
  for (const zone of FRONT_FLANK_ZONES) {
    const row = player.playedOrders[zone];
    if (!Array.isArray(row)) {
      continue;
    }
    count += row.filter(unit => unitCountsAsAsrahForFractureMinds(unit)).length;
  }
  return count;
}

export function getFractureMindsOutcomeForPlayer(player) {
  return countDeployedAsrahUnitsForFractureMinds(player) >= 4 ? 'destroy' : 'immobilize';
}
